export default {"src":"/_next/static/media/email-servers.90f8fd23.svg","height":512,"width":512,"blurWidth":0,"blurHeight":0};